import { SVGIconComponent } from './types';

export const Remote: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="27px"
    height="26px"
    viewBox="0 0 27 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g stroke="none" fill="none" transform="translate(0.5, 0)">
      <path
        d="M19,2.25000002 C20.2426407,2.25000002 21.25,3.25735931 21.25,4.5 L21.25,12.754 L19.75,11.448 L19.75,4.5 C19.75,4.08578644 19.4142136,3.75 19,3.75 L8,3.75 L7.92331687,3.75387217 C7.5451248,3.79227966 7.25,4.11167479 7.25,4.5 L7.25,21.5 C7.25,21.9142136 7.58578644,22.25 8,22.25 L19,22.25 C19.4142136,22.25 19.75,21.9142136 19.75,21.5 L19.7497306,19.8284136 C20.0748186,20.136279 20.56539,20.2355551 20.9992395,20.0422173 L21.25,19.93 L21.25,21.5 C21.25,22.7426407 20.2426407,23.75 19,23.75 L8,23.75 C6.75735931,23.75 5.75,22.7426407 5.75,21.5 L5.75,4.5 C5.75,3.25735931 6.75735931,2.25000002 8,2.25000002 L19,2.25000002 Z"
        id="Rectangle-2"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <g strokeWidth="1" fillRule="evenodd" transform="translate(17.3686, 10.8421)" fill="currentColor">
        <path
          d="M0.564968592,0.0845016572 L6.35532624,5.12662315 C6.59084671,5.33170942 6.44970497,5.71920468 6.13745621,5.72477082 L3.94358524,5.76387871 L4.71947609,7.46221188 C4.79825598,7.63465174 4.72127036,7.83824239 4.54810356,7.91541131 L3.30498152,8.4693881 C3.13408282,8.54554629 2.93373555,8.46978711 2.85598749,8.29960581 L2.07641601,6.59321614 L0.591160586,8.19607962 C0.380379533,8.4235511 0,8.27440923 0,7.96429324 L0,0.34168299 C0,0.0490774714 0.344299523,-0.107652321 0.564968592,0.0845016572 Z"
          id="Path"
          fillRule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
);
